"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDotGlobal = getDotGlobal;
exports.getGlobalUser = getGlobalUser;
exports.getRequest = getRequest;
exports.getRequestP = getRequestP;
exports.getWidgetHeight = getWidgetHeight;

var _ramda = require("ramda");

function getDotGlobal() {
  // @ts-ignore
  return window.DOT;
}

function getGlobalUser() {
  return (0, _ramda.pathOr)({}, ['widget', 'user'], getDotGlobal());
}

function getRequest(url, resolve, reject) {
  var request = new XMLHttpRequest();
  request.open('GET', url, true);

  request.onreadystatechange = function () {
    if (this.readyState === 4) {
      if (this.status >= 200 && this.status < 400) {
        resolve(JSON.parse(this.responseText));
      } else {
        reject();
      }
    }
  };

  request.send();
}

function getRequestP(url) {
  return new Promise(function (resolve, reject) {
    return getRequest(url, resolve, reject);
  });
}

function getWidgetHeight() {
  var widget = document.querySelector('.live-widget');
  var height = widget && widget.offsetHeight || 370;
  return height;
}